import React, { useEffect, useRef } from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";

import { useSelector, useDispatch } from "react-redux";

import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

import { fetchIndividualAssessments } from "../../store/thunks/fetch-individual-assessments-thunk";
import { fetchSignIn } from "../../store/thunks/fetch-sign-in-thunk";

import { selectSignIn } from "../../store/slices/signed-in-slice";
import { selectIndividualAssessmentsStatus, selectIndividualAssessmentsList } from "../../store/slices/individual-assessment-listings-slice";

import { IndividualAssessmentDetail } from "./IndividualAssessmentDetail";
import { fetchProfileStatus } from "../../store/thunks/fetch-profile-status-thunk";

export const IndividualAssessmentsInfo = () => {
    const individualAssessmentsStatus = useSelector(selectIndividualAssessmentsStatus);
    const individualAssessmentsList = useSelector(selectIndividualAssessmentsList)
    const isSignedIn = useSelector(selectSignIn);
    const dispatch = useDispatch();

    // On page load,
    // Get the status of applicant profile, whether or not the profile is complete with required fields.
    useEffect(() => {
        dispatch(fetchProfileStatus());
        dispatch(fetchIndividualAssessments());
    }, []);
        // If the job list has not been loaded
    // dispatch action to load the data
    useEffect(() => {
        if (individualAssessmentsStatus === "idle") {
            dispatch(fetchIndividualAssessments());
        }
    }, [individualAssessmentsStatus]);

    // Choose what to scroll to when loading in to the page
    const ref = useRef(null);

    // Extracts pathname property(key) from an object
    const { pathname } = useLocation();

    // Automatically scrolls to top whenever pathname changes
    useEffect(() => {
        ref.current?.scrollIntoView({ behavior: "smooth" });
    }, [pathname]);

    let content

    if (individualAssessmentsStatus === "loading") {
            content = (
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
        );
    } else if (individualAssessmentsStatus === "succeeded") {
        content = <p>Individual Assessments:</p>;
    } else if (!isSignedIn) {
        content = (
            <Col>
                Please{" "}
                <Link
                    style={{
                        textDecoration: "none"
                    }}
                    to={"/signin"}
                >
                    sign in
                </Link>{" "}
                to view Individual Assessments.
            </Col>
        );
    } else if (individualAssessmentsStatus === "failed" && individualAssessmentsList.length === 0) {
        content = <p>No Individual Assessments Found</p>
    }
    return (
            <>
                <Row
                    style={{
                        backgroundColor: "dimgray",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover"
                    }}
                    ref={ref}
                >
                    <Col xss={12} xs={12} xl={7} className="mx-auto">
                        <Row className="bg-body-secondary rounded-3 mx-auto shadow-lg border border-black border-1 border-opacity-10 mt-2">
                            <Row className="bg-body-secondary rounded-top-3 mx-auto">
                                <Row className="mx-auto justify-content-start bg-body-secondary">
                                    <Col className="col-auto pt-3 ">
                                        <h3 className="text-center opacity-75 mt-3 mb-4 border-bottom border-warning border-5 title-font h-50">
                                            {content}
                                        </h3>
                                    </Col>
                                </Row>
                            </Row>
                            <Row className="justify-content-center mx-auto">
                                <Row className="mb-3 pb-2">
                                    {individualAssessmentsList.length > 0 &&
                                        individualAssessmentsList.map((ia, index) => {
                                            return (
                                                <IndividualAssessmentDetail key={index} individualAssessment={ia}/>
                                            );
                                        })}
                                </Row>
                            </Row>
                        </Row>
                    </Col>
                </Row>
        </>
    )
}
